import MainTestScenario from './MainTestScenario';
import { constants } from '../../../../misc/helpers';
import { ScenarioEndType, ScenarioSceneType, StepToSkip } from '../../../../misc/BleedingControlScenario';

export default class MainTestScenarioSteps3And4 {
	constructor(private mainScenario: MainTestScenario, private onDone: (indx: number, aarReady3: boolean) => void, public showFailedAar: () => void) {
	}

	start() {
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});
		if(this.mainScenario.skipBCK === true) {
			this.step2PressureDressingSelected();
		}
		else {
			this.step1ShowBleedingControlKit();
		}
	}

	private step1ShowBleedingControlKit() {
		var context = this;
		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BleedingControlKit, {
			onSelectionChanged: (index: number) => {
				if(index === 0) {
					context.mainScenario.gameManager.UiManager.hideaAllUis();
					context.step2PressureDressingSelected();
				} 
				else if(index === 1) {
					context.onDone(-3, false);
				}
				else if(index === 2) {
					context.onDone(-2, false);
				}
				else {
					context.onDone(index, false)
				}
			}
		});
	}

	private step2PressureDressingSelected() {
		var context = this;

		context.mainScenario.gameManager.UiManager.showSingleUi(constants.InGameUINames.BinaryQuestion, {
			title: 'Would you like to apply pressure to the wound?',
			correctButton: {
				title: 'Yes',
				onClick: () => context.mainScenario.onAnsweredCorrectly('MainTestScenarioSteps3And4.step2PressureDressingSelected', () => context.step3ApplyPressureYes())
			},
			incorrectButton: {
				title: 'No',
				onClick: () => context.step3ApplyPressureNo()
			}
		});
	}
	// private step2PressureDressingNotSelected() {
	// 	var context = this;
	// 	context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
	// 	this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step1ShowBleedingControlKit());
	// }

	private step3ApplyPressureYes() {
		var context = this;
		if(this.mainScenario.scenarioSceneToLoad === ScenarioSceneType.scenarioD && this.mainScenario.endAt !== ScenarioEndType.firstTourniquete) {
			this.mainScenario.aarPDScenarioD = false;
			context.showFailedAar();
		}
		else {
			context.mainScenario.gameManager.UiManager.hideaAllUis();
					if(this.mainScenario.stepsOrder3 === true) {
						this.mainScenario.aarPressureDressing = true;
					}
					else {
						this.mainScenario.aarPressureDressing = false;
					}
					context.onDone(-1, true);
		}

		// context.mainScenario.playSequence('Steps3And4Cinematic', null, () => {
		// 	context.onDone();
		// });
	}

	private step3ApplyPressureNo() {
		this.step1ShowBleedingControlKit();
		// var context = this;
		// context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
		// this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step2PressureDressingSelected());
	}
}